<template>
  <div class="not-found">
    <Header></Header>
    <div class="not-found-content">
      <div class="content-wrapper">
        <h1>404</h1>
        <p>{{ $t('system.notFound.title') }}</p>
        <el-button class="custom-button"  type="primary" @click="backToHome">
          {{ $t('system.notFound.backHome') }}
        </el-button>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import Header from "../home/repeat/Header.vue";
import Lianjie from "../home/repeat/Lianjie.vue";
import Scroll from "../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";

const router = useRouter();

const backToHome = () => {
  router.push('/home');
};
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .not-found-content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 120px 0 50px;  // 增加顶部内边距，避免被头部遮挡
    margin-top: 80px;  // 添加顶部外边距，为固定定位的头部留出空间


    .content-wrapper {
      text-align: center;

      h1 {
        font-size: 120px;
        color: #004080;
        margin: 0;
        line-height: 1;
      }

      p {
        font-size: 24px;
        color: #666;
        margin: 20px 0 30px;
      }

      .el-button {
        padding: 12px 30px;
        font-size: 16px;
      }
      :deep(.custom-button) {
      background-color: #004080;
      border-color: #004080;
      
      &:hover {
        background-color: #005299;
        border-color: #005299;
      }
    }
    }
  }
}
</style>